export enum IntroMainContentVariants {
  default = 'default',
  newPlayer = 'newPlayer',
  existingPlayer = 'existingPlayer',
}

export type IntroMainContentProps = {
  variant?: IntroMainContentVariants;
};
